/**
 * ניצול נפח מול מגבלות המסלול החינמי (D14 א׳ 2ג).
 *
 * המגבלות — כפי שנבדקו ב־supabase.com/pricing ב־23.09.2026 (DECISIONS D14 §3).
 * אם Supabase ישנו אותן, יש לעדכן כאן ובמסמך ההחלטות.
 */

const MB = 1024 * 1024;

export const FREE_PLAN_LIMITS = {
  databaseBytes: 500 * MB,
  filesBytes: 1024 * MB,
} as const;

/** אזהרה למנהל מ־70% (D14). מ־90% — חמור: לפעול לפני שההעלאות ייחסמו. */
export const USAGE_WARN_RATIO = 0.7;
export const USAGE_CRITICAL_RATIO = 0.9;

export type UsageLevel = 'ok' | 'warn' | 'critical';

export interface UsageMeter {
  usedBytes: number;
  limitBytes: number;
  /** באחוזים שלמים, מעוגל כלפי מטה — 69.9% מוצג 69%, לא 70% */
  percent: number;
  level: UsageLevel;
}

export function usageMeter(usedBytes: number, limitBytes: number): UsageMeter {
  const used = Number.isFinite(usedBytes) && usedBytes > 0 ? usedBytes : 0;
  const ratio = limitBytes > 0 ? used / limitBytes : 0;
  return {
    usedBytes: used,
    limitBytes,
    percent: Math.floor(ratio * 100),
    level: ratio >= USAGE_CRITICAL_RATIO ? 'critical' : ratio >= USAGE_WARN_RATIO ? 'warn' : 'ok',
  };
}

/** ״312MB״ / ״1.2GB״ / ״850KB״ — לתצוגה בלבד. */
export function formatBytes(bytes: number): string {
  if (bytes >= 1024 * MB) return `${(bytes / (1024 * MB)).toFixed(2)}GB`;
  if (bytes >= MB) return `${Math.round(bytes / MB)}MB`;
  return `${Math.max(0, Math.round(bytes / 1024))}KB`;
}
